import { useContext } from 'react';
import { LocationAndLocalizationContext } from '../../../providers/LocationAndLocalizationProvider';
import { SECTION_DIVIDER_TEXT } from '../../../constants/localizations/auth';

import css from './auth-section-divider.module.scss';

const AuthSectionDivider = () => {
  const { getLocalizedText } = useContext(LocationAndLocalizationContext);

  return (
    <div
      data-testid="AuthSectionDividerContainer"
      className={css.dividerContainer}
    >
      <div className={css.dividerBar} />
      <div className={css.dividerText}>
        {getLocalizedText(SECTION_DIVIDER_TEXT)}
      </div>
      <div className={css.dividerBar} />
    </div>
  );
};

export default AuthSectionDivider;
